module.exports = __webpack_public_path__ + "static/media/coollogo_com-72345118.2af74ee7.svg";